
    <p class="percents" *ngIf="checkboxesCount">{{progressLinePersent}}%</p>
    <div class="progress_bar">        
      <div class="progress_checklist" *ngIf="checkboxesCount" [ngStyle]="progressStyle" (click)="setStyles()"></div>
    </div>
  